import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locale/en.json";
import esTranslation from "./locale/es.json";

import enTourTranslation from "./locale/tours/en.json";
import esTourTranslation from "./locale/tours/es.json";

import enContactTranslation from "./locale/contact/en.json";
import esContactTranslation from "./locale/contact/es.json";

import enAcquireTranslation from "./locale/acquire/en.json";
import esAcquireTranslation from "./locale/acquire/es.json";

import enDetailsTranslation from "./locale/details/en.json";
import esDetailsTranslation from "./locale/details/es.json";

import enAgendaTranslation from "./locale/agenda/en.json";
import esAgendaTranslation from "./locale/agenda/es.json";

import enReportsTranslation from "./locale/reports/en.json";
import esReportsTranslation from "./locale/reports/es.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
      tour: enTourTranslation,
      contact: enContactTranslation,
      acquire: enAcquireTranslation,
      details: enDetailsTranslation,
      agenda: enAgendaTranslation,
      reports: enReportsTranslation,
    },
    es: {
      translation: esTranslation,
      tour: esTourTranslation,
      contact: esContactTranslation,
      acquire: esAcquireTranslation,
      details: esDetailsTranslation,
      agenda: esAgendaTranslation,
      reports: esReportsTranslation,
    },
  },
  lng: "es", // Default language
  fallbackLng: "es", // Default language if translation is missing
  interpolation: {
    escapeValue: false, // React already escapes the content, so set to false
  },
});

export default i18n;
